import React from "react";
import "./MarkUnavailablePopup.css"; 
import warning from "../../../../../Assets/warning.svg";

const MarkUnavailablePopup = ({ activeCategory, isSliderOn, onConfirm, onCancel }) => {
  return (
    <div className="markunavailable-popup">
      <div className="markunavailable-popup-content">
        <div className="warning-icon">
          <img src={warning} alt="Warning" />
        </div>
        <p>  
       {isSliderOn  
        ? `Are you sure you want to make ${activeCategory} Available?`  
        : `Are you sure you want to make ${activeCategory} Unvailable?`}  
      </p> 
        <div className="unavailable-buttons">
          <button onClick={onConfirm} className="confirm-button">
            Yes
          </button>
          <button onClick={onCancel} className="cancel-button">
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarkUnavailablePopup;

